import { Selector } from "@ngxs/store";
import { TitleMaster, TitleModel, TitleState } from "./title.state";

export class TitleSelectors {
    @Selector([TitleState])
    static titleList(state: TitleMaster): TitleModel[] {
        return state.titleList
    }
    @Selector([TitleState])
    static title(state: TitleMaster, ttlkbn: string, ttlcd: string) {
        state.titleList?.find(x => x.ttlkbn === ttlkbn && x.ttlcd === ttlcd);
    }
}